(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement{
    constructor(){super()}
    connectedCallback(){
      this.header=document.querySelector('.section-header');
      this.headerIsAlwaysSticky=this.getAttribute('data-sticky-type')==='always'||this.getAttribute('data-sticky-type')==='reduce-logo-size';
      this.headerBounds={};
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change',this.setHeaderHeight.bind(this));
      if(this.headerIsAlwaysSticky){this.header.classList.add('shopify-section-header-sticky')}
      this.currentScrollTop=0;this.preventReveal=false;this.predictiveSearch=this.querySelector('predictive-search');
      this.onScrollHandler=this.onScroll.bind(this);this.hideHeaderOnScrollUp=()=>this.preventReveal=true;
      this.addEventListener('preventHeaderReveal',this.hideHeaderOnScrollUp);
      window.addEventListener('scroll',this.onScrollHandler,false);
      this.createObserver();
    }
    setHeaderHeight(){document.documentElement.style.setProperty('--header-height',`${this.header.offsetHeight}px`)}
    disconnectedCallback(){this.removeEventListener('preventHeaderReveal',this.hideHeaderOnScrollUp);window.removeEventListener('scroll',this.onScrollHandler)}
    createObserver(){let o=new IntersectionObserver((e,ob)=>{this.headerBounds=e[0].intersectionRect;ob.disconnect()});o.observe(this.header)}
    onScroll(){
      const y=window.pageYOffset||document.documentElement.scrollTop;
      if(this.predictiveSearch&&this.predictiveSearch.isOpen)return;
      if(y>this.currentScrollTop&&y>this.headerBounds.bottom){
        this.header.classList.add('scrolled-past-header');if(this.preventHide)return;requestAnimationFrame(this.hide.bind(this));
      }else if(y<this.currentScrollTop&&y>this.headerBounds.bottom){
        this.header.classList.add('scrolled-past-header');
        if(!this.preventReveal){requestAnimationFrame(this.reveal.bind(this))}else{
          window.clearTimeout(this.isScrolling);
          this.isScrolling=setTimeout(()=>{this.preventReveal=false},66);
          requestAnimationFrame(this.hide.bind(this));
        }
      }else if(y<=this.headerBounds.top){
        this.header.classList.remove('scrolled-past-header');requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop=y;
    }
    hide(){if(this.headerIsAlwaysSticky)return;this.header.classList.add('shopify-section-header-hidden','shopify-section-header-sticky');this.closeMenuDisclosure();this.closeSearchModal()}
    reveal(){if(this.headerIsAlwaysSticky)return;this.header.classList.add('shopify-section-header-sticky','animate');this.header.classList.remove('shopify-section-header-hidden')}
    reset(){if(this.headerIsAlwaysSticky)return;this.header.classList.remove('shopify-section-header-hidden','shopify-section-header-sticky','animate')}
    closeMenuDisclosure(){this.disclosures=this.disclosures||this.header.querySelectorAll('header-menu');this.disclosures.forEach(d=>d.close())}
    closeSearchModal(){this.searchModal=this.searchModal||this.header.querySelector('details-modal');this.searchModal.close(false)}
  }
  customElements.define('sticky-header',StickyHeader);

  /* ===== Inline search extras ===== */
  document.addEventListener('DOMContentLoaded', function(){
    var wrap = document.querySelector('.wa-header-search-wrap');
    if(!wrap) return;
    var form  = wrap.querySelector('.wa-inline-search__form');
    var input = wrap.querySelector('.wa-inline-search__input');
    var btn   = wrap.querySelector('.wa-inline-search__submit');
    if(!form || !input) return;
/* ---- Kill Firefox/Browser form history and handle double-click ---- */
try {
  // Stop browser from showing saved entries
  form.setAttribute('autocomplete', 'off');
  input.setAttribute('autocomplete', 'off');
  input.setAttribute('spellcheck', 'false');
  input.setAttribute('autocorrect', 'off');
  input.setAttribute('autocapitalize', 'off');

  // On double-click, suppress native dropdown and show OUR recent list
  input.addEventListener('dblclick', function(e){
    e.preventDefault();
    e.stopPropagation();

    // Briefly blur to hide the native dropdown, then refocus and open our panel
    const wasEmpty = isEmpty();
    input.blur();
    setTimeout(() => {
      input.focus({ preventScroll: true });
      if (wasEmpty) renderRecent(); else openPanel();
    }, 0);
  });
} catch(_) {}

    // Derive URLs without Liquid (works in all contexts, incl. theme editor)
var formAction = (function () {
  var f = document.querySelector('.wa-header-search-wrap form[action]') ||
          document.querySelector('form[action*="/search"]');
  return f ? f.getAttribute('action') : '/search';
})();

var SEARCH_URL = formAction.replace(/\/$/, '');         // e.g. "/search" or "/de/search"
var LOCALE_PREFIX = SEARCH_URL.replace(/\/search\/?$/, ''); // "" or "/de"
var ABS_ALL_URL = LOCALE_PREFIX + '/collections/all';
    function isEmpty(){ return input.value.trim()===''; }
    function handleEmpty(e){ if(isEmpty()){ e.preventDefault(); e.stopPropagation(); window.location.assign(ABS_ALL_URL);} }
    form.addEventListener('submit', handleEmpty); if(btn) btn.addEventListener('click', handleEmpty);

    var panel = document.createElement('div'); panel.className='wa-search-panel';
    panel.innerHTML = '<div class="wa-search-shelf"></div><div class="wa-panel-actions" style="display:none"><button type="button" data-clear>Clear history</button></div>';
    form.appendChild(panel);
    var shelf=panel.querySelector('.wa-search-shelf'), actions=panel.querySelector('.wa-panel-actions');
    function openPanel(){ panel.classList.add('is-open'); } function closePanel(){ panel.classList.remove('is-open'); }
    document.addEventListener('click', e => { if(!panel.contains(e.target) && !form.contains(e.target)) closePanel(); });

    var KEY='wa_recent_searches'; function getRecent(){ try{return JSON.parse(localStorage.getItem(KEY)||'[]')}catch(e){return[]} }
    function setRecent(v){ localStorage.setItem(KEY, JSON.stringify(v.slice(0,8))); }
    function pushRecent(q){ q=(q||'').trim(); if(!q) return; var list=getRecent().filter(v=>v.toLowerCase()!==q.toLowerCase()); list.unshift(q); setRecent(list); }
    actions.addEventListener('click', e=>{ if(e.target.matches('[data-clear]')){ localStorage.removeItem(KEY); renderRecent(); }});
    function renderRecent(){ var list=getRecent(); shelf.innerHTML=''; if(!list.length){ shelf.innerHTML='<div class="wa-search-empty">Start typing to search…</div>'; actions.style.display='none'; openPanel(); return; }
      shelf.insertAdjacentHTML('beforeend','<div class="wa-search-heading">Recent searches</div>');
      var tags=document.createElement('div'); tags.className='wa-recent-tags';
      list.forEach(q=>{ var a=document.createElement('a'); a.className='wa-recent-tag'; a.href=SEARCH_URL+'?q='+encodeURIComponent(q); a.textContent=q; tags.appendChild(a);});
      shelf.appendChild(tags); actions.style.display='flex'; openPanel(); }
    input.addEventListener('focus', ()=>{ if(isEmpty()) renderRecent(); });

    var debounce; input.addEventListener('input', function(){
      var q=input.value.trim(); if(q===''){ renderRecent(); return; }
      clearTimeout(debounce);
      debounce=setTimeout(function(){
        fetch(LOCALE_PREFIX + '/search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product,collection,query&resources[limit]=4&section_id=predictive-search',
      { headers: { 'Accept': 'application/json' } })
          .then(r=>r.ok?r.json():null).then(data=>{
            var res=(data&&data.resources&&data.resources.results)||{}; shelf.innerHTML='';
            if(res.queries&&res.queries.length){
              shelf.insertAdjacentHTML('beforeend','<div class="wa-search-heading">Suggestions</div>');
              res.queries.forEach(it=>{ shelf.insertAdjacentHTML('beforeend','<a class="wa-search-item" href="'+it.url+'"><span class="wa-search-thumb" style="display:inline-flex;align-items:center;justify-content:center">🔎</span><span>'+it.text+'</span></a>');});
            }
            if(res.products&&res.products.length){
              shelf.insertAdjacentHTML('beforeend','<div class="wa-search-heading">Products</div>');
              res.products.forEach(p=>{ var img=(p.image&&p.image)?p.image:null;
                shelf.insertAdjacentHTML('beforeend','<a class="wa-search-item" href="'+p.url+'">'+(img?'<img class="wa-search-thumb" src="'+img+'&width=80" alt="">':'<span class="wa-search-thumb"></span>')+'<span>'+p.title+'</span></a>');});
            }
            if(!shelf.innerHTML.trim()){ shelf.innerHTML='<div class="wa-search-empty">No results</div>'; }
            actions.style.display='none'; openPanel();
          }).catch(()=>{});
      },200);
    });
    form.addEventListener('submit', function(){ var q=input.value.trim(); if(q!=='') pushRecent(q); });
    /* Save queries from ANY search form (even the other header search) */
document.addEventListener('submit', function(e){
  try{
    var f = e.target;
    if (!f || f.tagName !== 'FORM') return;
    var qEl = f.querySelector('input[name="q"]');
    if (!qEl) return;
    var q = (qEl.value || '').trim();
    if (q) pushRecent(q); // writes to localStorage
  }catch(_){}
}, true); // capture so it runs before navigation

/* Also save when clicking search links (predictive / recent chips / etc.) */
document.addEventListener('click', function(e){
  var a = e.target.closest('a[href]');
  if (!a) return;
  try{
    var url = new URL(a.href, location.origin);
    if (url.pathname.match(/\/search\/?$/)) {
      var q = url.searchParams.get('q');
      if (q) pushRecent(q);
    }
  }catch(_){}
}, true);

  });

  /* ===== MOBILE drawer extras ===== */
  document.addEventListener('DOMContentLoaded', function(){
    const drawer = document.getElementById('Details-menu-drawer-container') || document.querySelector('details.menu-drawer-container');
    const nav = document.querySelector('.menu-drawer__navigation');

    if (drawer){
      const onToggle = () => { document.documentElement.classList.toggle('wa-drawer-open', drawer.hasAttribute('open')); };
      drawer.addEventListener('toggle', onToggle); onToggle();
    }
    if (!nav) return;

    const topTpl = document.getElementById('wa-mobile-top-src');
    if (topTpl && !nav.querySelector('.wa-mobile-top')){
      nav.prepend(topTpl.content.cloneNode(true));
    }

    const src = document.getElementById('wa-secondary-mobile-src');
    if (window.matchMedia('(max-width: 989px)').matches && src && !nav.querySelector('.wa-mobile-secondary')){
      const block = document.createElement('div');
      block.className = 'wa-mobile-secondary';
      block.innerHTML = src.innerHTML;
      nav.appendChild(block);
      block.querySelectorAll('a').forEach(a=>{
        a.classList.add('wa-row-link--plain');
        a.insertAdjacentHTML('beforeend','<span class="right">›</span>');
      });
    }

    const viewsTpl = document.getElementById('wa-l10n-views');
    let overlay;
    function ensureOverlay(){
      if (!overlay){
        overlay = viewsTpl.content.firstElementChild.cloneNode(true);
        const container = document.querySelector('.menu-drawer');
        container.appendChild(overlay);
        const root = overlay.querySelector('[data-view="root"]');
        const lang = overlay.querySelector('[data-view="lang"]');
        const cur  = overlay.querySelector('[data-view="cur"]');
        const show = v => { root.hidden = v!=="root"; lang.hidden = v!=="lang"; cur.hidden = v!=="cur"; overlay.classList.add('is-open'); };
        overlay.querySelector('[data-l10n-back]').addEventListener('click', () => { if (!root.hidden) { overlay.classList.remove('is-open'); return; } show('root'); });
        overlay.querySelector('[data-next="lang"]').addEventListener('click', e=>{ e.preventDefault(); show('lang'); });
        overlay.querySelector('[data-next="cur"]').addEventListener('click', e=>{ e.preventDefault(); show('cur'); });
      }
      return overlay;
    }

    nav.addEventListener('click', function(e){
      const btn = e.target.closest('[data-open-l10n]');
      if (!btn) return;
      e.preventDefault();
      ensureOverlay();
      overlay.classList.add('is-open');
      overlay.querySelector('[data-view="root"]').hidden = false;
      overlay.querySelector('[data-view="lang"]').hidden = true;
      overlay.querySelector('[data-view="cur"]').hidden  = true;
    });
  });

  /* ===== Desktop locale dropdown tabs ===== */
  document.addEventListener('DOMContentLoaded', function(){
    const dd = document.querySelector('.wa-locale .wa-locale-menu[data-wa-dd]');
    if(!dd) return;
    const tabs = dd.querySelectorAll('.wa-dd-tab');
    const panels = dd.querySelectorAll('[data-panel]');
    function activate(id){
      tabs.forEach(t => t.setAttribute('aria-selected', t.dataset.tab === id ? 'true' : 'false'));
      panels.forEach(p => p.hidden = (p.dataset.panel !== id));
    }
    tabs.forEach(t => t.addEventListener('click', e => { e.preventDefault(); activate(t.dataset.tab); }));
    const defaultTab = (dd.querySelector('.wa-dd-tab[aria-selected="true"]') || tabs[0]);
    if(defaultTab) activate(defaultTab.dataset.tab);
  });
  /* ---- Force Avada below the drawer, even if injected later ---- */
document.addEventListener('DOMContentLoaded', function(){
  const Z_BELOW_DRAWER = 2147483000;
  const SELECTORS = '.Avada-Faqs_Button,#Avada-FAQ_WidgetTrigger,.Avada-Launcher__ButtonCustom,.Avada-Launcher__Button--icon-only,iframe[src*="avada"]';

  function downrankAvada(){
    document.querySelectorAll(SELECTORS).forEach(n=>{
      n.style.setProperty('z-index', Z_BELOW_DRAWER, 'important');
    });
  }

  function toggleAvada(){
    const open = document.documentElement.classList.contains('wa-drawer-open');
    document.querySelectorAll(SELECTORS).forEach(n=>{
      if(open){
        n.style.setProperty('opacity','0','important');
        n.style.setProperty('pointer-events','none','important');
      }else{
        n.style.removeProperty('opacity');
        n.style.removeProperty('pointer-events');
      }
    });
  }

  downrankAvada();
  toggleAvada();

  new MutationObserver(downrankAvada).observe(document.body, {childList:true,subtree:true});
  new MutationObserver(toggleAvada).observe(document.documentElement, {attributes:true,attributeFilter:['class']});
});
/* Redirect any app-generated wishlist links to our custom page */
document.addEventListener('click', function(e){
  const a = e.target.closest('a[href*="/apps"][href*="wishlist"], a[href*="swishlist"][href*="wishlist"]');
  if (!a) return;
  e.preventDefault();
  window.location.href = '/pages/favorites';
});


  } catch(e) { console.error(e); }
})();
})();
